import { memo } from "react";
import { Grid, GridSpacing, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  document: {
    padding: "0px 20px",
  },
  documentItem: {
    margin: "8px 0px",
    paddingRight: 10,
  },
  card: {
    padding: "10px 10px 0px 10px",
    margin: "0px 0px 20px 0px",
    position: "relative",
  },
}));

export interface SchemaDataShow<T> {
  content: keyof T;
  label: string;
  size?:
    | boolean
    | "auto"
    | 1
    | 2
    | 3
    | 4
    | 5
    | 6
    | 7
    | 8
    | 9
    | 10
    | 11
    | 12
    | undefined;
  format?: (data: T | T[keyof T]) => any;
  formatAll?: boolean;
}

interface DataShowProps<T> {
  schema: Array<Array<SchemaDataShow<T>>>;
  data: T;
  paddign?: string;
  spacing?: GridSpacing;
}

function DataShow<T>({ schema, data, paddign, spacing }: DataShowProps<T>) {
  const classes = useStyles();

  return (
    <>
      {schema.map(
        (row, index) =>
          row && (
            <Grid
              key={index}
              style={{ padding: paddign ?? "0px 20px" }}
              className={classes.document}
              spacing={spacing}
              container
            >
              {row.map(
                (rowItem, index) =>
                  rowItem && (
                    <Grid
                      key={index}
                      direction="column"
                      className={classes.documentItem}
                      item
                      xs={rowItem.size || 12}
                    >
                      <Typography
                        variant="subtitle2"
                        style={{ marginBottom: 5 }}
                      >
                        {" "}
                        <b>{rowItem.label}</b>{" "}
                      </Typography>
                      <Typography variant="body2">
                        {data ? (
                          rowItem.formatAll ? (
                            rowItem.format(data)
                          ) : rowItem.format ? (
                            rowItem.format(data[rowItem.content])
                          ) : (
                            data[rowItem.content]
                          )
                        ) : (
                          <div>Não informado</div>
                        )}
                      </Typography>
                    </Grid>
                  )
              )}
            </Grid>
          )
      )}
    </>
  );
}

export default memo(DataShow) as any;
